import createListener from '../utils/createListener'

const getErrorMessage = error => {
  if (!error) {
    throw new Error('invalid error format')
  }

  if (error && error.message) {
    return error.message
  } else if (typeof error === 'string') {
    return error
  } else if (typeof error === 'object') {
    return JSON.stringify(error)
  }
  return String(error)
}

/* ------------------------------------ */

class Logger {
  constructor() {
    this.listener = createListener()
    this.transport = null
  }

  setTransport(transport) {
    if (transport) {
      this.transport = transport
    }
  }

  checkTransportMethod(transport, name) {
    return transport && typeof transport[name] === 'function'
  }

  dispatch(name, ...args) {
    if (this.checkTransportMethod(this.transport, name)) {
      return this.transport[name](...args)
    } else if (this.checkTransportMethod(console, name)) {
      return console[name](...args)
    }
  }

  info(...args) {
    if (process.env.NODE_ENV !== 'production') {
      this.dispatch('info', ...args)
    }
  }

  error(...args) {
    this.dispatch('error', ...args)
  }

  formatError(error, action, group) {
    const errorMsg = getErrorMessage(error)

    if (action && group) {
      return new Error(`[${group}] failed to "${action}", caused by ${errorMsg}`)
    } else {
      return new Error(errorMsg)
    }
  }

  errorWithAction(error, action, group) {
    this.error(this.formatError(error, action, group))
  }

  createLogger(group) {
    return {
      error: (error, action) => this.errorWithAction(error, action, group),
      info: (...args) => this.info(...args)
    }
  }
}

export default Logger